export default __webpack_public_path__ + "static/media/leaf@3x.c79225f9.png";